"use client";
import React from "react";
import Image from "next/image";
import { CheckCircle } from "lucide-react";
import { IAccommodation } from "../interface/IPackageDetails.interface";
// import pokhara from "@/assest/pokhara.png";
// import pokhara2 from "@/assest/Swyambhunath.png";

const Accomodation = ({
  accomodation: acc,
}: {
  accomodation: IAccommodation[];
}) => {
  const [selected, setSelected] = React.useState(acc?.[0]?.id);
  const current = acc.find((a: IAccommodation) => a?.id === selected)!;

  return (
    <>
      {acc && acc.length > 0 && (
        <div id="accommodation" className="w-full">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#9180BA] to-transparent py-3 px-3 text-white">
            Accommodation
          </div>

          {/* OPTIONS */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 px-6 mt-6">
            {acc.map((item: IAccommodation) => {
              const isActive = selected === item?.id;

              return (
                <button
                  key={item?.id}
                  onClick={() => setSelected(item?.id)}
                  className={`w-full flex flex-col items-center rounded-lg border transition-all duration-150 overflow-hidden
                ${isActive ? "border-green-600" : "border-grey-200"}
              `}
                >
                  <div
                    className={`flex items-center justify-center w-full h-10
                  ${isActive ? "bg-green-600" : "bg-white"}`}
                  >
                    {isActive && (
                      <CheckCircle size={20} className="text-white" />
                    )}

                    <span
                      className={`ml-2 typography-mid-body-light
                    ${isActive ? "text-white" : "text-black"}`}
                    >
                      {item?.type}
                    </span>

                    {!isActive && (
                      <span className="ml-2 text-green-500 typography-mid-body-light">
                        {item?.title}
                      </span>
                    )}
                  </div>
                </button>
              );
            })}
          </div>

          {/* PREVIEW AREA */}
          <div className="px-6 py-6">
            <div className="border border-grey-200 rounded-lg w-[77vw] md:w-[35vw] lg:w-[20vw] overflow-hidden">
              <Image
                src={current?.image || "/placeholder.png"}
                alt="Room"
                width={700}
                height={400}
                className="w-full h-56 object-cover"
              />

              <div className="m-3 typography-large-body-light text-grey-500">
                {current?.title}
                <p
                  className="text-green-500 mt-2"
                  dangerouslySetInnerHTML={{
                    __html: current?.description || "",
                  }}
                ></p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Accomodation;
